import axios from "axios";
import { useQuery } from "react-query";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL +
  "/BusinessLicensePermitDashboard/BusinessLicensePermitDashboard";

export interface BLPSummaryCountsDto {
  total: number;
  active: number;
  inactive: number;
  pending: number;
  expired: number;
  expiring: number;
}

export interface BLPLicenseTypeDistributionDto {
  licenseType?: string;
  count: number;
}

export interface BLPRenewalStatusItemDto {
  renewalStatus?: string;
  statusCount: number;
  percentage: number;
}

export interface BLPRenewalStatusDto {
  total: number;
  statuses: BLPRenewalStatusItemDto[];
}

export interface BLPOfficeRiskDto {
  officeId: number;
  officeName?: string;
  missingLicenses: number;
  upcomingRenewals: number;
  totalRisk: number;
}

export interface BLPDashboardDto {
  summaryCounts: BLPSummaryCountsDto;
  distributionByType: BLPLicenseTypeDistributionDto[];
  renewalStatus: BLPRenewalStatusDto;
  officeRisk: BLPOfficeRiskDto[];
}

export const getBLPDashboard = async (): Promise<BLPDashboardDto> => {
  const response = await axios.get<BLPDashboardDto>(apiBaseUrl);

  return response.data;
};

export const useBLPDashboard = (
  isFranchise: boolean,
  isNonFranchise: boolean,
  enabled: boolean = true,
) => {
  return useQuery(
    ["BLPDashboard", isFranchise, isNonFranchise],
    getBLPDashboard,
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );
};
